export default "__VITE_ASSET__BZNDl$qL__"